import { render, staticRenderFns } from "./AdminOptions.vue?vue&type=template&id=0a868b4c&scoped=true"
import script from "./AdminOptions.vue?vue&type=script&lang=js"
export * from "./AdminOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a868b4c",
  null
  
)

export default component.exports